import { REQUEST, SUCCESS, FAILURE } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

export const initialState = {
  clients: {},
  clientsAreLoaded: false,

  managersTotal: {},
  managersTotalAreLoaded: false,

  managers: {},
  managersAreLoaded: false,

  analyticsData: {},
  analyticsDataIsLoaded: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_CRM_CLIENTS_ANALYTICS[REQUEST]:
      return { ...state, clientsAreLoaded: false };
    case ActionTypes.GET_CRM_CLIENTS_ANALYTICS[SUCCESS]: {
      return { ...state, clients: action.data, clientsAreLoaded: true };
    }
    case ActionTypes.GET_CRM_CLIENTS_ANALYTICS[FAILURE]:
      return { ...state, error: action.error, clientsAreLoaded: false };

    case ActionTypes.GET_CRM_MANAGERS_ANALYTICS[REQUEST]:
      return { ...state, managersAreLoaded: false };
    case ActionTypes.GET_CRM_MANAGERS_ANALYTICS[SUCCESS]:
      return { ...state, managers: action.data, managersAreLoaded: true };
    case ActionTypes.GET_CRM_MANAGERS_ANALYTICS[FAILURE]:
      return { ...state, error: action.error, managersAreLoaded: false };

    case ActionTypes.GET_CRM_ANALYTICS[REQUEST]:
      return { ...state, analyticsDataIsLoaded: false };
    case ActionTypes.GET_CRM_ANALYTICS[SUCCESS]:
      return { ...state, analyticsData: action.data, analyticsDataIsLoaded: true };
    case ActionTypes.GET_CRM_ANALYTICS[FAILURE]:
      return { ...state, error: action.error, analyticsDataIsLoaded: false };
    default:
      return state;
  }
};

export default reducer;
